import { request } from '../request';
import GlobalConfig from '@/global/config';

// 更新维度评分
export function editDimensionScore(data, params) {
  const surveyId = GlobalConfig.getSurveyId();
  const pmList = Object.entries(params || {});
  const pmArr = pmList.map(([key, value]) => `${key}=${value}`);
  return request({
    url: `/wenjuan/surveyDimension/update/${surveyId}${pmList.length > 0 ? `?${pmArr.join('&')}` : ''}`,
    method: 'post',
    data: { ...data, surveyId },
  });
}

// 维度设置列表
export function getDimensionSettings() {
  const surveyId = GlobalConfig.getSurveyId();
  return request({
    url: `/wenjuan/surveyDimension/getOrInit/${surveyId ?? ''}`,
    method: 'get',
  });
}

// 新增维度
export function addDimension(data) {
  const surveyId = GlobalConfig.getSurveyId();
  return request({
    url: `/wenjuan/surveyDimension/createOrUpdate/${surveyId ?? ''}`,
    method: 'post',
    data
  });
}

// 编辑维度
export function editDimension(data) {
  const surveyId = GlobalConfig.getSurveyId();
  return request({
    url: `/wenjuan/surveyDimension/editDimensionNames/${surveyId ?? ''}`,
    method: 'post',
    data
  });
}

// 删除维度
export function removeDimension(data) {
  const surveyId = GlobalConfig.getSurveyId();
  return request({
    url: `/wenjuan/surveyDimension/deleteDimensionNames/${surveyId ?? ''}`,
    method: 'post',
    data
  });
}

// 题目绑定列表
export function getTopicBinds() {
  const surveyId = GlobalConfig.getSurveyId();
  return request({
    url: `/wenjuan/surveyDimension/getDimensionExamBySurveyId/${surveyId ?? ''}`,
    method: 'get',
  });
}

// 标准分/权重设置列表
export function getStandardScoreWeightSettings() {
  const surveyId = GlobalConfig.getSurveyId();
  return request({
    url: `/wenjuan/surveyDimension/computeScore/${surveyId ?? ''}`,
    method: 'post',
  });
}

// 保存标准分/权重
export function saveStandardScoreWeight(data) {
  const surveyId = GlobalConfig.getSurveyId();
  return request({
    url: `/wenjuan/surveyDimension/scoreAndWeightSet/${surveyId}`,
    method: 'post',
    data
  });
}

// 标准分/权重设置状态切换
export function setStandardScoreWeightSettingStatus(data) {
  const surveyId = GlobalConfig.getSurveyId();
  return request({
    url: `/wenjuan/surveyDimension/standardScoreAndWeightOpenSet/${surveyId ?? ''}`,
    method: 'post',
    data,
  });
}

// 题目绑定 弹窗获取全部考试题
export function getAllQuestion() {
  const surveyId = GlobalConfig.getSurveyId();
  return request({
    url: `/wenjuan/wjsurvey/getWjSurveyExamQeustionById/${surveyId ?? ''}`,
    method: 'get',
  });
}

// 对题目进行绑定
export function bindTopic(data) {
  const surveyId = GlobalConfig.getSurveyId();
  return request({
    url: `/wenjuan/surveyDimension/bingDimensionQuestion/${surveyId}`,
    method: 'post',
    data
  });
}

// 对题目进行解绑
export function unbindTopic(data) {
  const surveyId = GlobalConfig.getSurveyId();
  return request({
    url: `/wenjuan/surveyDimension/unbindDimensionQuestion/${surveyId}`,
    method: 'post',
    data
  });
}

// 维度新增结果建议
export function addResultAdvice(data, params) {
  const surveyId = GlobalConfig.getSurveyId();
  const pmList = Object.entries(params || {});
  const pmArr = pmList.map(([key, value]) => `${key}=${value}`);
  return request({
    url: `/wenjuan/surveyDimension/updateScoreRange?surveyId=${surveyId}${pmList.length > 0 ? `&${pmArr.join('&')}` : ''}`,
    method: 'post',
    data: { ...data, surveyId }
  });
}

// 更新测试说明
export function editInstruction(instruction) {
  const surveyId = GlobalConfig.getSurveyId();
  return request({
    url: `/wenjuan/surveyDimension/updateByInstruction/${surveyId}`,
    method: 'post',
    data: { instruction }
  });
}